import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormControl, Modal, Table } from 'react-bootstrap';
import StepNav from './StepNav.jsx';

const AddProjectModalKml = ({
	steps,
	step,
	confirmAndClose,
	next,
	addProjectKmlFileChange,
	kmlIconWarning
}) => {
	return (
		<React.Fragment>
			<Modal.Body>
				<StepNav steps={steps} step={step} />
				<Table className="projectSetupTable">
					<tbody>
						<tr>
							<td>Choose an KML File</td>
							<td>
								<FormControl
									componentClass="input"
									onChange={addProjectKmlFileChange}
									type="file"
									label="KML File" />
							</td>
						</tr>
						{kmlIconWarning && kmlIconWarning.length
							? (
								<tr>
									<td colSpan={2}>
										<div className="alert alert-warning" role="status">
											<p>
												This KML references local icon files the browser cannot load.
												They will be replaced with standard map pins. The original file is kept.
											</p>
											<ul>
												{kmlIconWarning.map(href => <li key={href}>{href}</li>)}
											</ul>
										</div>
									</td>
								</tr>
							)
							: null}
					</tbody>
				</Table>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={confirmAndClose} bsStyle="danger" className="floatLeft">Cancel</Button>
				<Button bsStyle="primary" onClick={next}>Next</Button>
			</Modal.Footer>
		</React.Fragment>
	);
};

AddProjectModalKml.propTypes = {
	steps: PropTypes.array,
	step: PropTypes.number,
	confirmAndClose: PropTypes.func,
	next: PropTypes.func,
	addProjectKmlFileChange: PropTypes.func,
	kmlIconWarning: PropTypes.arrayOf(PropTypes.string)
};

export default AddProjectModalKml;